import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UploadHistory } from 'src/app/Modules/settings/models/idms/data-upload.model';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
export interface PeriodicElement {
    event_label: string;
    event_time: string;
    upload_type: string;
    username: string;
    comments: string;
    action: any;
}
const ELEMENT_DATA: PeriodicElement[] = [
    { event_label: 'Pipe spec Upload', event_time: '09/01/2023 10:31:21', upload_type: 'pipe spec', username: 'abc', comments: 'demo', action: '' },
    { event_label: 'Joint Upload', event_time: '09/04/2023 10:31:21', upload_type: 'Joint', username: 'abc ', comments: '', action: '' },
    { event_label: 'Joint Upload', event_time: '12/04/2023 06:42:10', upload_type: 'Joint', username: 'xyz', comments: '', action: '' },
    { event_label: 'Pipe spec Upload', event_time: '18/08/2023   12:05:21', upload_type: 'pipe spec', username: 'abc', comments: 'demo', action: '' },
];

@Component({
    selector: 'app-data-restore-table',
    templateUrl: './data-restore-table.component.html',
    styleUrls: ['./data-restore-table.component.scss'],
    standalone: false
})
export class DataRestoreTableComponent implements OnInit {
    displayedColumns: string[] = ['event', 'status', 'createdDate', 'type', 'user', 'action'];
    @Input() uploadHistory: UploadHistory[];
    panelOpenState = false;
    tooltip_position = 'above';
    dataSource = new MatTableDataSource<any>();

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    constructor(
        private documentApiService: DocumentApiService,
        private customToastService: CustomToastService,
        private ngxUiLoaderService: NgxUiLoaderService
    ) {}

    ngOnInit(): void {
        this.dataSource.data = this.uploadHistory;
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    DownloadFiles(url: string) {
        this.ngxUiLoaderService.start();
        this.documentApiService.getUploadedImage([url], localStorage.getItem('currentInstanceId')).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.response) {
                        let res_ = res.response[0];
                        // Step 1: Validate MIME type
                        const allowedMimeTypes = [
                            'application/pdf',
                            'application/vnd.ms-excel',
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'image/png',
                            'image/jpeg',
                            'text/plain',
                        ];
                        if (!allowedMimeTypes.includes(res_.contentType)) {
                            throw new Error('Blocked: Invalid content type');
                        }

                        // Step 2: Decode base64 safely
                        let byteArray: Uint8Array;
                        try {
                            const byteCharacters = atob(res_.content); // base64 decode
                            // const byteNumbers = Array.from(byteCharacters).map((c) => c.charCodeAt(0));
                            // byteArray = new Uint8Array(byteNumbers);
                            const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            byteArray = new Uint8Array(byteNumbers);
                        } catch (error) {
                            console.error('Invalid base64 content', error);
                            return;
                        }
                        const rawFileName = res_.path?.split('/').pop() || 'downloaded-file';
                        const fileName = rawFileName.replace(/[^a-zA-Z0-9_\-.]/g, '_'); // Only safe characters
                        // Ensure the Blob gets an ArrayBuffer-backed view (some environments
                        // may expose a SharedArrayBuffer via the original buffer type).
                        const view = new Uint8Array(byteArray);
                        const blob = new Blob([view], {
                            // use the actual contentType returned from server for flexibility
                            type: res_.contentType || 'application/octet-stream',
                        });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();

                        // Step 3: Sanitize file name

                        // Step 4: Create blob and safe <a> element
                        // const blob = new Blob([byteArray], { type: res_.contentType });
                        // const url = URL.createObjectURL(blob);

                        // const link = document.createElement('a');
                        // Object.defineProperties(link, {
                        //     href: { value: url, writable: false },
                        //     download: { value: fileName, writable: false },
                        // });
                        // link.style.display = 'none';

                        // // Step 5: Append and trigger download
                        // document.body.appendChild(link); // Safe now that inputs are sanitized
                        // link.click();
                        // document.body.removeChild(link);
                        // URL.revokeObjectURL(url);
                        this.ngxUiLoaderService.stop();
                    } else {
                        this.customToastService.errorToast(res.message, 'Error');
                        this.ngxUiLoaderService.stop();
                    }
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }
    // dataSource = this.uploadHistory;
}
